/**
 * API layer dashboard admin — thống kê tổng quan.
 */
import { apiClient } from '../../../../shared/services/apiClient';
import { API_ROUTES } from '../../../../shared/constants/apiRoutes';

/** Các hàm gọi API dashboard. */
export const dashboardApi = {
  /** Số liệu thống kê và quick actions. */
  getDashboard: () => apiClient.get(API_ROUTES.adminDashboard),
};
